<template>
    <div class="card-chart">
        <div class="card-body" id="chart_container">
            <div id="tv_chart_container" style="height:540px !important"></div>
        </div>
    </div>
</template>
<script setup>
import JsCookie from "js-cookie";
import {onMounted} from "vue";
import {makeTvDatafeed} from "../../exchange/Chart/makeTvDatafeed.js";

onMounted(() => {
    loadChart()
})

const loadChart = () => {
    const widget = window.tvWidget = new TradingView.widget({
        debug: false,
        fullscreen: false,
        symbol: window.pageData.market.title.replace('_', '/'),
        interval: '60',
        container: 'tv_chart_container',
        datafeed: makeTvDatafeed({baseUrl: `${window.baseUrl}charts`}),
        library_path: `${window.baseUrl}tradingview/charting_library/`,
        locale: "en",
        disabled_features: ["use_localstorage_for_settings", "study_templates", "timeframes_toolbar", "header_symbol_search", "header_saveload", "header_screenshot"],
        enabled_features: [""],
        theme: JsCookie.get("darkmode"),
    });

    widget.onChartReady(function () {
        widget.chart().createStudy('Volume', false, true);
    });
}

defineExpose({loadChart})
</script>
